// extracted by mini-css-extract-plugin
export var background = "bK_x";
export var backgroundContainer = "bK_fw";
export var bottomWave = "bK_cT";
export var buttons = "bK_cr";
export var container = "bK_h";
export var content = "bK_cf";
export var icon = "bK_bw";
export var iconContainer = "bK_b1";
export var middleWave = "bK_cS";
export var negativeTop = "bK_hk";
export var overlap = "bK_hm";
export var section = "bK_b";
export var selected = "bK_bg";
export var tab = "bK_d4";
export var tabText = "bK_d3";
export var title = "bK_f";
export var topWave = "bK_hl";